import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DatePeriod2y4m7pf19ebgd as DatePeriod,
  DateTimePeriod384alsehm5scz as DateTimePeriod,
  Companion_instance3kamikfo48xfz as Companion_instance,
} from '../DateTimePeriod.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DatePeriodSerializerClass;
function DatePeriodSerializer() {
  if (DatePeriodSerializerClass === VOID) {
    class $ {
      constructor() {
        DatePeriodSerializer_instance = this;
        this.$$delegate_0__1 = DatePeriodIso8601Serializer_getInstance();
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DatePeriod', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_3e32w3_k$(encoder, value) {
        this.$$delegate_0__1.serialize_3e32w3_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3e32w3_k$(encoder, value instanceof DatePeriod() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return this.$$delegate_0__1.deserialize_sy6x50_k$(decoder);
      }
    }
    initMetadataForObject($, 'DatePeriodSerializer', VOID, VOID, [KSerializer()]);
    DatePeriodSerializerClass = $;
  }
  return DatePeriodSerializerClass;
}
var DatePeriodSerializer_instance;
function DatePeriodSerializer_getInstance() {
  if (DatePeriodSerializer_instance === VOID)
    new (DatePeriodSerializer())();
  return DatePeriodSerializer_instance;
}
var DateTimePeriodSerializerClass;
function DateTimePeriodSerializer() {
  if (DateTimePeriodSerializerClass === VOID) {
    class $ {
      constructor() {
        DateTimePeriodSerializer_instance = this;
        this.$$delegate_0__1 = DateTimePeriodIso8601Serializer_getInstance();
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DateTimePeriod', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_khwvh_k$(encoder, value) {
        this.$$delegate_0__1.serialize_khwvh_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_khwvh_k$(encoder, value instanceof DateTimePeriod() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return this.$$delegate_0__1.deserialize_sy6x50_k$(decoder);
      }
    }
    initMetadataForObject($, 'DateTimePeriodSerializer', VOID, VOID, [KSerializer()]);
    DateTimePeriodSerializerClass = $;
  }
  return DateTimePeriodSerializerClass;
}
var DateTimePeriodSerializer_instance;
function DateTimePeriodSerializer_getInstance() {
  if (DateTimePeriodSerializer_instance === VOID)
    new (DateTimePeriodSerializer())();
  return DateTimePeriodSerializer_instance;
}
var DatePeriodIso8601SerializerClass;
function DatePeriodIso8601Serializer() {
  if (DatePeriodIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        DatePeriodIso8601Serializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DatePeriod/ISO', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        var period = Companion_instance.parse_pc1q8p_k$(decoder.decodeString_x3hxsx_k$());
        var tmp;
        if (period instanceof DatePeriod()) {
          tmp = period;
        } else {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(period.toString() + ' is not a date-based period');
        }
        return tmp;
      }
      serialize_3e32w3_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3e32w3_k$(encoder, value instanceof DatePeriod() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DatePeriodIso8601Serializer', VOID, VOID, [KSerializer()]);
    DatePeriodIso8601SerializerClass = $;
  }
  return DatePeriodIso8601SerializerClass;
}
var DatePeriodIso8601Serializer_instance;
function DatePeriodIso8601Serializer_getInstance() {
  if (DatePeriodIso8601Serializer_instance === VOID)
    new (DatePeriodIso8601Serializer())();
  return DatePeriodIso8601Serializer_instance;
}
var DateTimePeriodIso8601SerializerClass;
function DateTimePeriodIso8601Serializer() {
  if (DateTimePeriodIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        DateTimePeriodIso8601Serializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DateTimePeriod/ISO', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_instance.parse_pc1q8p_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_khwvh_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_khwvh_k$(encoder, value instanceof DateTimePeriod() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DateTimePeriodIso8601Serializer', VOID, VOID, [KSerializer()]);
    DateTimePeriodIso8601SerializerClass = $;
  }
  return DateTimePeriodIso8601SerializerClass;
}
var DateTimePeriodIso8601Serializer_instance;
function DateTimePeriodIso8601Serializer_getInstance() {
  if (DateTimePeriodIso8601Serializer_instance === VOID)
    new (DateTimePeriodIso8601Serializer())();
  return DateTimePeriodIso8601Serializer_instance;
}
//region block: exports
export {
  DatePeriodSerializer_getInstance as DatePeriodSerializer_getInstance41w3hzzadrlu,
  DateTimePeriodSerializer_getInstance as DateTimePeriodSerializer_getInstance1njysvzzhpdqj,
};
//endregion

//# sourceMappingURL=DateTimePeriodSerializers.mjs.map
